import { render, staticRenderFns } from "./isr-enajenacion-inmuebles-pfisicas.vue?vue&type=template&id=56037022&lang=html&"
import script from "./isr-enajenacion-inmuebles-pfisicas.vue?vue&type=script&lang=js&"
export * from "./isr-enajenacion-inmuebles-pfisicas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports